import React from 'react';
import { BeatLoader } from 'react-spinners';

export interface OKomRadioOption {
    value: string;
    label: string;
}

interface OKomRadioGroupProps {
    legend: string;
    /** Used as the radio inputs' `name` attribute; must be unique per group on the page. */
    name: string;
    options: OKomRadioOption[];
    value?: string;
    onChange?: (value: string) => void;
    /** Shows a BeatLoader next to the legend (e.g. while an AI-detected value is being fetched). */
    loading?: boolean;
    /** Lay the options out horizontally on one line instead of stacked. */
    inline?: boolean;
}

const OKomRadioGroup: React.FC<OKomRadioGroupProps> = ({ legend, name, options, value, onChange, loading, inline }) => {
    return (
        <fieldset className="ods-fieldset ods-fieldset--no-border">
            <legend className="ods-fieldset__legend">
                {legend}
                {loading && (
                    <span className="ods-margin-left-1" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                        <BeatLoader color="#2a2859" size={8} />
                    </span>
                )}
            </legend>
            <div style={inline ? { display: 'flex', flexWrap: 'wrap', gap: '1.5rem' } : undefined}>
                {options.map(opt => (
                    <div key={opt.value} className="ods-radio">
                        <label className="ods-radio__input">
                            <input
                                type="radio"
                                name={name}
                                value={opt.value}
                                checked={value === opt.value}
                                onChange={() => onChange && onChange(opt.value)}
                            />
                            <span className="ods-radio__control"></span>
                            <span className="ods-radio__text">{opt.label}</span>
                        </label>
                    </div>
                ))}
            </div>
        </fieldset>
    );
};

export default OKomRadioGroup;
